// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"73":"1459712d","184":"3ea20775","236":"0de2c19f","280":"bec74648","488":"3cc1a7d6","680":"4dc5dc8c","699":"20f101a9","915":"403491aa"}[chunkId] + ".css";
};